module.exports = __webpack_public_path__ + "img/fenxiangxiaoke.80e8725a.png";